import { render } from "./BlogArticle.vue?vue&type=template&id=c3fc396c&scoped=true&ts=true"
import script from "./BlogArticle.vue?vue&type=script&lang=ts"
export * from "./BlogArticle.vue?vue&type=script&lang=ts"

import "./BlogArticle.vue?vue&type=style&index=0&id=c3fc396c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fc396c"]])

export default __exports__